import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { getLocalStorage } from "../../local-storage";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { UsuarioService } from "../../usuario/usuario.service";
import { firstValueFrom, Observable } from "rxjs";
//import { onAuthStateChanged } from "@angular/fire/auth/firebase";
//import { onAuthStateChanged } from "@angular/fire/auth";

export const authenticatedGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorage = getLocalStorage();
  const user = localStorage?.getItem("user");

  if (user === "null" || user === null || user === undefined) {
    console.log("user authenticatedGuard if ", user);
    router.navigate(["/login"]);
    return false;
  } else {
    console.log("user authenticatedGuard else ", user);
    return true;
  }
};

export const ValidaLectura: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const usuarioService = inject(UsuarioService)
  const auth = getAuth();
  await auth.authStateReady();
  const user = auth.currentUser;

  if (user && user.uid) {
    const urlToGO = router.getCurrentNavigation()?.finalUrl?.toString();

    if(urlToGO == '/entrada/new/add')
      return true;

    const permisos = await firstValueFrom(usuarioService.getTemasLectura());
    for(let key in permisos) {
      let tema = permisos[key];
      if(urlToGO?.includes(tema)) {
        return true;
      }
    }
  }

  router.navigate(["/agenda"]);
  return false;
};